module.exports = __webpack_public_path__ + "img/box7-8.f89bd541.png";